import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EditableTable from '../../components/EditableTable';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import useInventoryAdjustmentAPI from '../../apis/inventoryAdjustmentAPI';
import { genUniqueNumbers } from '../../../utils/genUniqueID';
import AdjustmentReason from '../../modals/AdjustmentReasonModal';
import EventEmitter from '../../../utils/eventEmitter';
import AuthContext from '../../../utils/AuthContext';
// import EditableTable from '../../../globalComponents/EditableTable';



const columns = [
  {
    title: 'Location',
    dataIndex: 'location_id',
    key: 'location_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Package',
    dataIndex: 'package_id',
    key: 'package_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'On Hand',
    dataIndex: 'available_quantity',
    key: 'available_quantity',
    // editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Counted Quantity',
    dataIndex: 'counted_quantity',
    key: 'counted_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Difference',
    dataIndex: 'quantity_difference',
    key: 'quantity_difference',
    // editable: false,
    width: '10%',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <span className={record.quantity_difference > 0 ? 'text-[#04c910]' : record.quantity_difference < 0 && 'text-red-600'}>{record.quantity_difference}</span>
  },
  {
    title: 'Scheduled Date',
    dataIndex: 'scheduled_date',
    key: 'scheduled_date',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  // {
  //   title: 'User',
  //   dataIndex: 'user_id',
  //   key: 'user_id',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  // },
  {
    title: '',
    key: 'operation',
    editable: false,
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/inventory-adjustments'}>
        EDIT
      </Link>
    )
  }
]



const ProductInventoryAdjustment = () => {
  const {productInvAdjustment, product, locations} = useLoaderData();
  const [editingKey, setEditingKey] = useState('');
  const [adjustments, setAdjustments] = useState(productInvAdjustment);
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const { user } = useContext(AuthContext);
  const { create, update, apply } = useInventoryAdjustmentAPI();
  const params = useParams();
  const navigate = useNavigate();
  // console.log(locations) 
  
  const onClick = (record) => {
    let data = {...record};
    data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
    
    if (productInvAdjustment.length > 0) {
      const item = productInvAdjustment.find(prod => (prod.location_id === data.location_id) && (prod.product_id === data.product_id));
      data['event'] = 'UPDATE';
      data['id'] = item.id;
      data['status'] = 'applied';
      data['inventory_location'] = product.inventory_location;
      // console.log(item)  
    }
    EventEmitter.dispatch('openproinvenreason', {open: true, data});
    
  }

  // console.log(productInvAdjustment)
  const handleSave = async (record, newData) => {
    try {
      let data = {...record};
      data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
      data.user_id = user.id;
      if (productInvAdjustment.length > 0) {
        const item = productInvAdjustment.find(prod => (prod.location_id === data.location_id) && (prod.product_id === data.product_id));
        // console.log(item)
        if (data.event === 'CLEAR') {
          
          await update(data, success);
          return;
        }else {
          if (item) {
            data['event'] = 'UPDATE';
            data['id'] = item.id;
            data['status'] = 'save';
            data['inventory_location'] = product.inventory_location;
            if (data.id === undefined) {
              data['event'] = 'CREATE';
            }
          }else {
            data['event'] = 'NEW_STOCK';
            await update(data, success);
            return;
          }
        }
      }else {
        data['event'] = 'CREATE';
      }
      // delete data.status;
      
      await update(data, success);
      // delete data.quantity;
      // setAdjustments(newData);
      
    }catch (err) {
      throw err;
    }
  }

  // console.log(adjustments);

  const handlenavigate = (record) => {

    let code = {id: params.id, loc: record.location_id, inv_loc: product.inventory_location};
    navigate(`/inventory/products/${encodeURIComponent(JSON.stringify(code))}/update-quantity/moves-history`);
  } 
 

  const addLine = () => {
    let adjustments_ = [...adjustments];
    let obj = {
      key: genUniqueNumbers(10),
      location_id: '',
      product_id: product.id,
      package_id: '',
      quantity: 0,
      counted_quantity: null,
      quantity_difference: 0,
      scheduled_date: new Date(),
      user_id: user.id,

    };
    adjustments_.push(obj);
    setAdjustments(adjustments_);
    setEditingKey(obj.key);
  }
  useEffect(() => {
    EventEmitter.subscribe('adjustment_response', data => {
      navigate(0);
    });
    return () => EventEmitter.unsubscribe('adjustment_response');
  },[])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb /></h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'} onClick={addLine}>New</Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <RowEditableTable
        dataSource={adjustments}
        setDataSource={setAdjustments}
        columns={columns}
        apiSave={handleSave}
        handlenavigate={handlenavigate}
        // addLine={addLine}
        // option1={[]}
        // option2={[]}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        options={{products: [product], users: [], locations: locations}}
        onClick={onClick}
        triggers={[]}
        routes={[]}
      />
      <AdjustmentReason create={apply} success={success}/>
    </div>
  )
}

export default ProductInventoryAdjustment;